
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { dashedVid } from '@/utils/index'
import VSwiper from '@/components/Swiper/index.vue'
import Verification from '@/components/Verification/index.vue'
import FSwiper from '@/components/Swiper/file.vue'
import WebPage from '@/components/Webpage/index.vue'
import '@/components/ProductInfo/index.scss'
import { dateFormat } from '@/utils/index'
@Component({
  components: {
    VSwiper,
    Verification,
    FSwiper,
    WebPage
  },
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop() private landingInfo!: any
  @Prop({default: () => {
    return []
  }}) private additionDcuList!: Array<any>
  
  /// data
  private data: Object = {}
  
  /// provide data
  @Provide() provideData: Object = {}

  private get headTitle(): any {
    if(this.landingInfo && this.landingInfo.customizedLp){
      let {custom} = this.landingInfo.activity
      return custom.textplain_015
    }
    return this.$t('app.product_info')
  }
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }

  private previewIndex: number = new Date().getTime()

  private get dashedTxid(): string {
    //   dashedVid
    let {sku} = this.landingInfo
    let txId = sku && sku.blockinfo && sku.blockinfo.txId || ""
    return dashedVid(txId)
  }


  private get productFiles(): Array<any> {
    let {sku} = this.landingInfo
    let moreImages = (sku && sku.base && sku.base.files) || []
    return moreImages
  }

  private get productLinks(): Array<any> {
    let {sku} = this.landingInfo
    let moreImages = (sku && sku.custom && sku.custom.otherlist1589267752295) || []
    return moreImages
  }

  private get productImages(): Array<any> {
    let {sku} = this.landingInfo
    let moreImages = (sku && sku.custom && sku.custom.Moreimages) || (sku && sku.custom && sku.custom.otherlist1589267722263) || []
    return moreImages.map((item: any) => {
        return item.filelocation
    })
  }
  private get productDescribe(): string {
    let {sku} = this.landingInfo
    let desc = sku && sku.base && sku.base.description
    return desc && desc.replace(/\\n/g, '')
  }
  private get parameters(): Array<any> {

    let {sku} = this.landingInfo
    return (sku && sku.custom && sku.custom.Productparameters) ||
    (sku && sku.base && sku.base.productparames) || []
  }
  private get verification(): Array<any> {
    let {sku} = this.landingInfo
    return (sku && sku.verificationinfo) || []
  }
  private openTxRecord() {
      let {sku, explorerUrl} = this.landingInfo
      let txId = sku && sku.blockinfo && sku.blockinfo.txId || ""
      // let timestamp = sku && sku.base&& sku.base.timestamp && dateFormat(sku.base.timestamp, 'yyyy-MM-dd hh:mm:ss') || ""
      // console.log("blockinfo", sku)
      // txId && window.open(explorerUrl + "/transactions/" + txId)
      // this.$router.push({name: "BlockDetail",  query: {txId: txId}})
      if(document.domain.endsWith(".cn")){
        this.$router.push({name: "BlockDetail",  query: {txId: txId}})
      }else{
        txId && window.open(explorerUrl + "/transactions/" + txId)
      }
  }

  public currentIndex: any = 1
  public swipChangeIndex(index: any) {
    this.$refs.swipe && (this.$refs.swipe as any).swipeTo((index - 1));
  }

  /// lifecycle
  created() {
    
  }
  
  mounted() {
    setTimeout(()=>{
      this.$refs.swipe && (this.$refs.swipe as any).resize();
    }, 1000)
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  public swipChange(index: any): void {
    console.log("swip_change", index)
    this.currentIndex = index + 1
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }
}
